import * as React from "react";
import Link from 'gatsby-link';
import { GoogleAnalyticsEventType } from "../../models/google-analytics";
import * as googleAnalyticsService from "../../services/google-analytics-service";
import styled from "styled-components";

/** FeaturesBoxSimpleBlockElement */
interface FeaturesBoxSimpleBlockElementProps extends FeatureElementData {}

const FeaturesBoxSimpleBlockElement = (props: FeaturesBoxSimpleBlockElementProps) => {
  const {featureIconClassName,featureName,featureText} = props;
  return (
    <FeaturesBoxSimpleBlockElementWrapper className="block-grid-item wow zoomIn" data-wow-duration="500ms" data-wow-delay="100ms">
      <div className="shadow-effect">
        <span className={`typcn typcn-${featureIconClassName}`}/>
        <h3>{featureName}</h3>
        <p>{featureText}</p>
      </div>
    </FeaturesBoxSimpleBlockElementWrapper>
  )
};

/** STYLES => FeaturesBoxSimpleBlockElement */

const FeaturesBoxSimpleBlockElementWrapper = styled.div`
  div.shadow-effect {
    min-height: 271px;
    box-shadow: 0 19px 38px rgba(0, 0, 0, 0.1), 0 15px 12px rgba(0, 0, 0, 0.02), 0 -3px 10px -3px rgba(0,0,0,0.1);
  }
  span {
    margin-top: 35px !important;
    display: block;
  }
  h3 {
    font-size: 18px !important;
    color: #808080;
    margin-top: 0px;
  }
  p {
    margin: 0 -2px !important;
  }
`;

/** FeaturesBoxSimpleBlock */
interface FeaturesBoxSimpleBlockProps {
  /** FICZERY */
  features: FeaturesBoxSimpleBlockElementProps[]

  /** INFO CZY MA BYĆ JAKIŚ NAPIS POD FICZERAMI */
  featuresDescription?: boolean

  /** LINK DO NAPISÓW POD FICZERAMI */
  featuresDescriptionLink?: string

  /** FICZERY BACKGROUND => DOMYŚLNIE BIAŁE */
  featuresBackground?: string

  /** GOOGLE EVENT TO TRIGGER ON SECTION VIEW */
  componentViewEventType?: GoogleAnalyticsEventType

  /** GOOGLE EVENT TYPE TO TRIGER ON BUTTON CLICK */
  buttonClickEventType?: GoogleAnalyticsEventType
}

interface FeaturesBoxSimpleBlockState {}

class FeaturesBoxSimpleBlock extends React.Component<FeaturesBoxSimpleBlockProps,FeaturesBoxSimpleBlockState> {

  constructor(props: FeaturesBoxSimpleBlockProps) {
    super(props);
    this.onComponentView = this.onComponentView.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  onComponentView() {
    if (this.props.componentViewEventType) {
      googleAnalyticsService.trackEvent(this.props.componentViewEventType);
    }
  }

  onButtonClick() {
    if (this.props.buttonClickEventType) {
      googleAnalyticsService.trackEvent(this.props.buttonClickEventType);
    }
  }

  render() {
    const {features} = this.props;
    return (
      <div className="goodgrowth-theme-styles" onMouseEnter={this.onComponentView}>
        <FeaturesBoxSimpleBlockWrapper className="services2-list" featuresBackground={this.props.featuresBackground}>
          <div className="row">
            <div className="col-sm-12">
              <div className="block-grid-md-3 block-grid-sm-2 block-grid-xs-1">

                {features.map((feature: FeaturesBoxSimpleBlockElementProps, index: number) =>
                  <FeaturesBoxSimpleBlockElement
                    key={index}
                    {...feature}
                  />
                )}

              </div>
            </div>
          </div>

          {this.props.featuresDescription &&
          <div className="row">
            <FeatureBoxFooterWrapper className="card-action">
              <p>
                Więcej informacji na ten temat znajduje się <Link to={this.props.featuresDescriptionLink} target="_blank" onClick={this.onButtonClick}>tutaj</Link>.
              </p>
            </FeatureBoxFooterWrapper>
          </div>
          }

        </FeaturesBoxSimpleBlockWrapper>
      </div>
    )
  }

}

/** STYLES */

const FeaturesBoxSimpleBlockWrapper: any = styled.section`
  ${(props: any) => props.featuresBackground ? `background: ${props.featuresBackground} !important;` : `background: none !important;`}
`;

const FeatureBoxFooterWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px !important;
  text-align: center;
  margin-bottom: -30px;
  p {
    margin: 0;
  }
  a {
    margin-top: -5px;
    margin-right: 0 !important;
    text-transform: none !important;
    color: #1976d2 !important;
    text-decoration: underline;
  }
`;

export default FeaturesBoxSimpleBlock


// WEBPACK FOOTER //
// ./src/layouts/features-box-simple-block/features-box-simple-block.tsx